import { render, staticRenderFns } from "./AdminAppSvg.vue?vue&type=template&id=14d1f51c&"
import script from "./AdminAppSvg.vue?vue&type=script&lang=ts&"
export * from "./AdminAppSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports